"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
function update(...args) {
    if (args.length === 2) {
        return function curriedUpdate(obj) {
            return update(obj, ...args);
        };
    }
    else {
        const [obj, prop, updater] = args;
        return Object.assign(Object.assign({}, obj), { [prop]: updater(obj[prop]) });
    }
}
exports.update = update;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBkYXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VwZGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxTQUFnQixNQUFNLENBQUMsR0FBRyxJQUFXO0lBQ2pDLElBQUksSUFBSSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDbkIsT0FBTyxTQUFTLGFBQWEsQ0FBQyxHQUFRO1lBQ2xDLE9BQVEsTUFBYyxDQUFDLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFDO1FBQ3pDLENBQUMsQ0FBQTtLQUNKO1NBQU07UUFDSCxNQUFNLENBQUMsR0FBRyxFQUFFLElBQUksRUFBRSxPQUFPLENBQUMsR0FBRyxJQUFJLENBQUM7UUFDbEMsdUNBQ08sR0FBRyxLQUNOLENBQUMsSUFBSSxDQUFDLEVBQUUsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxJQUM3QjtLQUNKO0FBQ0wsQ0FBQztBQVpELHdCQVlDIn0=